import FinalPageContainer from './final-page-container';

export default FinalPageContainer;
